
    import * as React from 'react';

    const Redo24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" fill="none" style={svgStyle}><path fillRule="evenodd" clipRule="evenodd" d="M17.5292 4.72324C14.6835 3.04921 11.0698 2.81867 7.91006 4.42866C2.98917 6.93598 1.03258 12.9577 3.5399 17.8786C6.04723 22.7995 12.069 24.7561 16.9899 22.2488C20.454 20.4837 22.4492 16.977 22.4521 13.3387L21.3804 13.3387C21.3778 16.5872 19.5964 19.7182 16.5035 21.2941C12.1098 23.5328 6.73323 21.7859 4.49455 17.3922C2.25588 12.9986 4.00283 7.62199 8.39648 5.38331C11.2849 3.91159 14.5981 4.16239 17.1653 5.75528L13.1575 6.37073L13.3201 7.42974L19.4543 6.48777L17.0025 0.7865L16.0183 1.20978L17.5292 4.72324Z" /></svg>
        </div>
      );
    };

    Redo24.displayName = 'Redo24';

    export default Redo24;
  